import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  downloadApp() {
    // Here you would typically implement the download functionality
    // For now, we'll just open a new window with a download link
    window.open('https://your-app-download-link.com', '_blank');
  }
} 